import fetcher from '../utils/api';

const trackService = {
  trackPageView: async (page) => {
    return fetcher(`track/page_view/`, 'POST', true, {
      page
    });
  },
  trackCopyLink: async (documentId, location) => {
    return fetcher(`track/copy_link/`, 'POST', true, {
      document_id: documentId,
      location
    });
  },
  trackCopyEmbed: async (documentId, format) => {
    return fetcher(`track/copy_embed/`, 'POST', true, {
      document_id: documentId,
      format
    });
  },
  trackCioEvent: async (eventName, eventFields) => {
    return fetcher(`track/cio/`, 'POST', true, {
      event_name: eventName,
      event_fields: eventFields
    });
  }
};

export default trackService;
